import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { Space } from '../../Space/src/Space.js';
import modules_74c5b1b9 from '../styles/Dialog.module.less.js';
import DialogContext from './DialogContext.js';

/**
 * @description The Dialog component is used to show content on top of an overlay that requires user interaction
 *
 * @component
 * @example
 * ```jsx
 * <Header title="Title">content</Dialog>
 * ```
 */
const Header = React.forwardRef((props, ref) => {
    const { title, subtitle, icon, className, children, ...restProps } = props;
    const cx = useStyles(modules_74c5b1b9);
    const { fullscreen } = React.useContext(DialogContext);
    const classNames = cx(className, 'header', {
        fullscreen,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Space, { ref: ref, size: 16, align: "center", className: classNames, ...restProps },
            icon && React.createElement("div", { className: cx('icon') }, icon),
            title || subtitle ? (React.createElement(Space, { direction: "vertical", size: 8, className: cx('title-wrapper') },
                title && React.createElement("div", { className: cx('title') }, title),
                subtitle && React.createElement("div", { className: cx('subtitle') }, subtitle))) : null),
        children));
});
Header.defaultProps = {};
Header.displayName = 'Header';

export { Header };
//# sourceMappingURL=Header.js.map
